import Category from '../../../../../domain/entities/writer/faq/Category';

export const CONCACT_CATEGORY_IDS = [3, 4, 7];

export type FormValues = {
  title: string;
  content: string;
  selectedCategory: Category;
};
